/* istanbul ignore file */
import React, { useEffect } from 'react';
import { Button } from 'framework/ui/mui-builder';
import { SubmitButton } from 'framework/ui/ui-builder';
import { useFormContext, ZoneDateTimeInput, ZonedApiDateFormat } from 'framework/form';
import screeningFormValidationSchema from './screeningFormValidationSchema';
import GeneralInterviewerEmployeeInput from '../../input/GeneralInterviewerEmployeeInput';
import { Box } from '@mui/material';

interface ScreeningFormProps {
  handleCancelClick: () => void;
}

const ScreeningForm = ({ handleCancelClick }: ScreeningFormProps) => {
  const { submitForm, isSubmitEnabled, isLoadingArtifact, setValidationSchemaAction } = useFormContext();

  useEffect(() => {
    if (setValidationSchemaAction) {
      setValidationSchemaAction(screeningFormValidationSchema);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ZoneDateTimeInput
        label="Interview date"
        source="interviewDateTime"
        apiDateFormat={ZonedApiDateFormat.ISO_8601_DATETIME_WITH_OFFSET}
        isRequired
        closeOnSelect={false}
      />
      <GeneralInterviewerEmployeeInput label="Interviewer" source="interviewerAlias" isRequired />

      <Box display="flex" gap={1.25}>
        <SubmitButton
          key="submit-modal-btn"
          onClick={submitForm}
          isLoading={!isSubmitEnabled}
          disabled={isLoadingArtifact}
        />
        <Button
          variant="outlined"
          key="cancel-modal-btn"
          onClick={handleCancelClick}
          disabled={!isSubmitEnabled || isLoadingArtifact}
        >
          Cancel
        </Button>
      </Box>
    </>
  );
};

export default ScreeningForm;
